import * as React from 'react';

import { getAnalystRating } from "../../utils";
const internalStyles = require('./AnalystRating.pcss');

interface IProps {
    stars?: number;
}

export class AnalystRating extends React.Component<IProps, {}>{
    constructor(props) {
        super(props);
    }

    render() {
        let rating = getAnalystRating(this.props.stars || 0);
        if (rating.image === "") {
            return <span>n/a</span>
        }
        return (
            <img height="18px" style={{width:"auto"}} src={require(`../../images/b_${rating.image}.svg`)} />
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/assets/AnalystRating/AnalystRating.tsx